import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import {
  HomeOutlined,
  ApartmentOutlined,
  TeamOutlined,
  ProfileOutlined,
  BranchesOutlined,
  GlobalOutlined,
  HeatMapOutlined,
} from '@ant-design/icons';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';

const { Sider } = Layout;

const Sidebar = ({ isMobile, toggleSidebar }) => {
  const [collapsed, setCollapsed] = useState(false);

  const menuItems = [
    {
      key: 'sub1',
      icon: <HomeOutlined />,
      label: 'घर',
      children: [
        { key: '6', label: <Link to="/houseList">घरको सुची</Link> },
        { key: '7', label: <Link to="/houseLocation">घरहरुको स्थान</Link> },
        { key: '8', label: <Link to="/house-chart">घरहरुको मानचित्र</Link> },
      ],
    },
    {
      key: 'sub2',
      icon: <TeamOutlined />,
      label: 'परिवार',
      children: [
        { key: '9', label: <Link to="/familyList">परिवारको सुची</Link> },
        { key: '10', label: <Link to="/familyChart">परिवारको मानचित्र</Link> },
      ],
    },
    {
      key: 'sub3',
      icon: <ApartmentOutlined />,
      label: 'संस्था',
      children: [
        { key: '1', label: <Link to="/organizationList">संस्थाको सुची</Link> },
        { key: '2', label: <Link to="/organizationLocation">संस्थाहरुको स्थान</Link> },
        { key: '3', label: <Link to="/organizationChart">संस्थाहरुको मानचित्र</Link> },
        { key: '4', label: <Link to="/ward-list">वडाको सुची</Link> },
        { key: '5', label: <Link to="/tole-list">टोलको सुची</Link> },
      ],
    },
    {
      key: '11',
      icon: <ProfileOutlined />,
      label: 'योजना',
      children: [
        { key: '12', label: <Link to="/planningList">योजना</Link> },
      ],
    },
    {
      key: 'sub4',
      icon: <BranchesOutlined />,
      label: 'बाटो',
      children: [
        { key: '13', label: <Link to="/roadList">बाटोको सुची</Link> },
        { key: '14', label: <Link to="/all-road">बाटोको संजाल</Link> },
      ],
    },
    {
      key: 'sub5',
      icon: <GlobalOutlined />,
      label: 'दर्ता',
      children: [
        { key: '15', label: <Link to="/registration-list">दर्ताको सुची</Link> },
      ],
    },
    {
      key: 'sub6',
      icon: <GlobalOutlined />,
      label: 'चलानी',
      children: [
        { key: '16', label: <Link to="/invoice-list">चलानिको सुची</Link> },
      ],
    },
    {
      key: 'sub7',
      icon: <HeatMapOutlined />,
      label: 'बिभिन्न क्षेत्रहरु',
      children: [
        { key: '17', label: <Link to="/map-list">विभिन्न क्षेत्रहरु</Link> },
      ],
    },
  ];

  return (
    <>
      {/* Mobile Full-Width Sidebar */}
      {isMobile ? (
        <div className="fixed top-0 left-0 z-50 h-full w-full bg-gray-800">
          <div className="flex justify-between items-center p-4 bg-gray-700">
            <h3 className="text-white">Menu</h3>
            <CloseOutlined
              className="text-white text-xl cursor-pointer"
              onClick={toggleSidebar}
            />
          </div>
          <div className="overflow-y-auto h-full">
            <Menu
              mode="inline"
              theme="dark"
              defaultSelectedKeys={['1']}
              className="bg-gray-800 text-white"
              items={menuItems}
            />
          </div>
        </div>
      ) : (
        /* Desktop Sidebar */
        <div
          className="fixed top-19 left-0 h-full w-64 bg-gray-800 hidden lg:block"
        >
          <div className="overflow-y-auto h-full">
            <Menu
              mode="inline"
              theme="dark"
              defaultSelectedKeys={['1']}
              className="bg-gray-800 text-white"
              items={menuItems}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
